import React from 'react';

import { Container, ContainerProps } from '@lglp/components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { SOCIAL } from 'translations';

import { getTitle } from '../../helpers/seo';
import { RootState } from '../../reducers';
import ShareButton from './ShareButton';
import styles from './ShareSocialMedia.module.scss';
import { getSocialMediaDefinitions, SocialMediaNames } from './SocialMedia';

export const ShareSocialMedia: React.FC<ShareSocialMediaComponentProps> = ({
  className,
  ...rest
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const currentDocument = useSelector(
    (state: RootState) => state.main?.document
  );
  const title = getTitle(false)(currentDocument);

  const socialMediaDefinitions = getSocialMediaDefinitions(
    [
      SocialMediaNames.FACEBOOK,
      SocialMediaNames.TWITTER,
      SocialMediaNames.LINKEDIN,
    ],
    title,
    location.pathname
  );

  return (
    <Container className={[styles.shareMediaButtonWrapper, className]}>
      <Container className={styles.shareSocialMedia} {...rest}>
        <span className={styles.titleShare}>{t(SOCIAL.SHARE)}</span>
        {socialMediaDefinitions.map((socialMediaDefinition) => (
          <ShareButton
            className={styles.shareButton}
            key={socialMediaDefinition.key}
            name={socialMediaDefinition.key}
            {...socialMediaDefinition}
          />
        ))}
      </Container>
    </Container>
  );
};

type ShareSocialMediaComponentProps = ContainerProps;
